// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"366":"aa99d749","548":"aa99d749"}[chunkId] + ".chunk.css";
};